// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-k_gQ","advertDetailHeaderPrice__value":"c-k_gR","advertDetailHeaderPrice__label":"c-k_gS"};